import React, { useState, useEffect, useContext } from 'react';
import { API } from '../../API/API';
import ButtonDefault from '../../components/ButtonDefault/ButtonDefault';
import { Modal } from '@fluentui/react';
import { message } from 'antd';
import { MessageConst } from '../../const/MessageConst';
import ButtonSecondary from '../../components/ButtonSecondary/ButtonSecondary';
import { UserContext } from '../../context/UserContext';
import { MessageBar, MessageBarType, getTheme, } from '@fluentui/react';
import { IconButton } from '@fluentui/react/lib/Button';
import FieldText from '../../components/FieldText/FieldText';
import ButtonSecondaryWithLoad from '../../components/ButtonSecondaryWithLoad/ButtonSecondaryWithLoad';


const EmailVerify = (props) => {

    const { setUserInfo, userInfo } = useContext(UserContext);
    const [initData] = useState(
        {
            "email": userInfo?.email,
            "code": null
        }
    );
    const [data, setData] = useState({ ...initData });
    const [warning, setWarning] = useState();
    const [isSent, setIsSent] = useState(userInfo?.emailverificationstatus == "Pending");
    const [isTimerRunning, setIsTimerRunning] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(60);

    useEffect(() => {
        let interval = null;

        if (isTimerRunning && secondsLeft > 0) {
            interval = setInterval(() => {
                setSecondsLeft((secondsLeft) => secondsLeft - 1);
            }, 1000);
        } else {
            setIsTimerRunning(false);
            setSecondsLeft(60);
        }

        return () => clearInterval(interval);
    }, [isTimerRunning, secondsLeft]);

    const fieldOnChanged = async (key, text, field) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            setData(tData);
        }
    }

    const isValidEmail = (email) => {
        // Regular expression to validate email format
        const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/;

        return emailRegex.test(email);
    };

    const onSend = async () => {
        let isValid = true;
        let tempData = { ...data }

        if (!isValidEmail(tempData.email)) {
            isValid = false;
            setWarning("Зөв имэйл оруулна уу!");
        }

        if (isValid) {
            let param = {
                "userID": userInfo.userid.toUpperCase(),
                "email": tempData.email
            }
            await API.post('/api/shared/user-management/user/SendVerification', param).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    setIsSent(true);
                    localStorage.setItem('userInfo', JSON.stringify({
                        ...userInfo,
                        emailverificationstatus: "Pending"
                    }));
                    setUserInfo({
                        ...userInfo,
                        emailverificationstatus: "Pending"
                    });
                }
            }).catch(res => {
                setWarning(res.response.data.retmsg);
            });
        }
    }

    const onResend = async () => {
        onSend();
        setIsTimerRunning(true);
    }

    const onVerify = async () => {
        let isValid = true;
        let tempData = { ...data }

        if (!isValidEmail(tempData.email)) {
            isValid = false;
            setWarning("Зөв имэйл оруулна уу!");
        }
        if (!tempData.code) {
            isValid = false;
            setWarning("Код оруулна уу!");
        }

        if (isValid) {
            let param = {
                "userID": userInfo.userid.toUpperCase(),
                "email": tempData.email,
                "code": tempData.code
            }
            await API.post('/api/shared/user-management/user/VerifyEmail', param).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    localStorage.setItem('userInfo', JSON.stringify({
                        ...userInfo,
                        emailverificationstatus: "Verified"
                    }));
                    setUserInfo({
                        ...userInfo,
                        emailverificationstatus: "Verified"
                    });
                    props.onClick();
                }
            }).catch(res => {
                setWarning(res.response.data.retmsg);
            });
        }
    }

    const theme = getTheme();

    const iconButtonStyles = {
        root: {
            color: theme.palette.neutralPrimary,
            marginLeft: "90%",

        },
        rootHovered: {
            color: theme.palette.neutralDark,
        },
    };
    const cancelIcon = { iconName: 'Cancel' };

    return (
        <Modal
            isOpen={props.isOpen}
        >
            <IconButton
                styles={iconButtonStyles}
                iconProps={cancelIcon}
                ariaLabel="Close popup modal"
                onClick={() => { props.onClick(); }}
            />
            <div style={{ padding: 20, width: 400 }}>
                {
                    !isSent &&
                    (<FieldText title="И-мэйл" onChanged={fieldOnChanged} keyfield='email' type={'email'} defaultValue={data.email} />)
                }
                {
                    isSent &&
                    (<>
                        <div>
                            <FieldText title="И-мэйл" onChanged={fieldOnChanged} keyfield='email' type={'email'} defaultValue={data.email} disable={true} />
                        </div>
                        <div style={{ marginTop: 20 }}>
                            <FieldText required={true} title="Баталгаажуулах код" onChanged={fieldOnChanged} autoFocus={true} keyfield='code' defaultValue={data.code} />
                        </div>
                    </>)
                }
                {warning && (<div style={{ marginBottom: 16, marginTop: 16 }}>
                    <MessageBar
                        messageBarType={MessageBarType.warning}
                        isMultiline={false}
                        dismissButtonAriaLabel='Close'
                    >
                        {warning}
                    </MessageBar>
                </div>)}
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
                    {!isSent && (
                        <>
                            <div >
                                <ButtonSecondary text='Болих' onClick={() => { props.onClick(); }} />
                            </div>
                            <div style={{ marginLeft: 16 }}>
                                <ButtonDefault text="Илгээх" onClick={onSend} />
                            </div>
                        </>)}
                    {isSent && (
                        <>
                            <div style={{ marginLeft: 16 }}>
                                <ButtonSecondaryWithLoad text={isTimerRunning ? `Дахин илгээх ${secondsLeft}` : 'Дахин илгээх'} onClick={onResend} loading={isTimerRunning} />
                            </div>
                            <div style={{ marginLeft: 16 }}>
                                <ButtonDefault text="Баталгаажуулах" onClick={onVerify} />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Modal>
    );
}

export default EmailVerify;